import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filter',
    pure:false
})
export class FilterPipe implements PipeTransform {
    transform(barChartData: any[], filter: any): any {
        if (!barChartData || !filter) {
            return barChartData;
        }
        debugger
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        //return barChartData.filter(item => item.dataType.indexOf(filter.dataType) !== -1);
        return barChartData.filter(item => item.dataType == 'selectedCity' || item.dataType == 'query');
    }
}


// WEBPACK FOOTER //
// ./src/app/services/FilterPipe.ts